module.exports = __webpack_public_path__ + "static/media/vietnam-flag.9873e081.png";